<!-- Container, role banner is same as header-->
<div
  id="header"
  tabindex="-1"
  role="banner"
  class="custom_accordion"
  (dragenter)="preventDrop($event)"
  (dragover)="preventDrop($event)"
  (drop)="preventDrop($event)">
  <mat-accordion>
    <mat-expansion-panel [disabled]="true" [expanded]="panelOpenState" class="toolbar" hideToggle>
      <mat-expansion-panel-header [collapsedHeight]="collapsedHeight" [expandedHeight]="expandedHeight">
        <mat-panel-description>
          <a
            #nibioLogo
            (keyup.enter)="nibioLogo.click()"
            class="nibio-logo-wrapper"
            draggable="false"
            href="{{ logoUrl }}"
            tabindex="-1"
            target="_blank">
            <img
              [ngClass]="name === 'vega' ? 'logo' : 'nibio-logo'"
              draggable="false"
              tabindex="0"
              src="{{ logo }}"
              alt="NIBIO" />
          </a>
          <!--Kilden-->
          <h1 class="toolbar-text hidden-mobile">{{ title }}</h1>

          <!--Søkefelt-->
          <kilden3-search class="search"></kilden3-search>

          <!--Dropdown verktøy-->
          <button
            (keydown.enter)="$event.stopPropagation()"
            role="button"
            #menuTrigger="matMenuTrigger"
            [class.opened]="menuTrigger.menuOpen"
            class="toolbar-nav-tools no-margin-right navigation-style tools-btn tools-btn-left"
            [matMenuTriggerFor]="toolsmenu">
            <mat-icon class="toggle-panel">construction</mat-icon>
            <span>Verktøy</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <div class="moveRight">
            @if (name === 'vega' && logo2) {
              <img class="logo" src="{{ logo2 }}" />
            }
            @if (name === 'vega' && logo3) {
              <img class="logo" src="{{ logo3 }}" />
            }
            @if (name === 'vega' && logo4) {
              <img class="logo" src="{{ logo4 }}" />
            }
            @if (name === 'vega' && logo5) {
              <img class="logo" src="{{ logo5 }}" />
            }
          </div>

          <!-- Mat-menu for desktop and mobile -->
          <mat-menu class="custom_mat_menu" #toolsmenu="matMenu" hasBackdrop="false">
            <!-- Wildlife -->
            @if (shouldShowTool('viltkart')) {
              <button
                (click)="openWildlifeDialog()"
                [ngClass]="{ 'hidden-mobile': !shouldShowToolMobile('viltkart') }"
                mat-menu-item>
                <mat-icon class="black-icon">area_chart</mat-icon>
                Dyreportalen
              </button>
            }

            <!-- Zones -->
            @if (shouldShowTool('sonegrenser')) {
              <mat-divider
                [ngClass]="{
                  'hidden-mobile': !shouldShowToolMobile('sonegrenser'),
                }">
              </mat-divider>
            }
            @if (shouldShowTool('sonegrenser')) {
              <button
                (click)="openGrantZonesDialog()"
                [ngClass]="{
                  'hidden-mobile': !shouldShowToolMobile('sonegrenser'),
                }"
                mat-menu-item>
                <mat-icon class="black-icon">area_chart</mat-icon>
                Finn sone for distriktstilskudd
              </button>
            }

            <!-- Draw -->
            @if (shouldShowTool('draw') || shouldShowTool('measure')) {
              <mat-divider
                [ngClass]="{
                  'hidden-mobile': !shouldShowToolMobile('draw') && !shouldShowToolMobile('measure'),
                }">
              </mat-divider>
            }
            @if (shouldShowTool('draw') || shouldShowTool('measure')) {
              <button
                (click)="openDrawDialog()"
                [disabled]="$is3dActive()"
                [ngClass]="{
                  'hidden-mobile': !shouldShowToolMobile('draw') && !shouldShowToolMobile('measure'),
                }"
                [title]="$is3dActive() ? 'Ikke tilgjengelig i 3D-modus' : 'Tegning og måling i kartet'"
                mat-menu-item>
                <mat-icon class="black-icon">design_services</mat-icon>
                Tegne/måle
              </button>
            }

            <!-- Compare -->
            @if (shouldShowTool('compare')) {
              <mat-divider [ngClass]="{ 'hidden-mobile': !shouldShowToolMobile('compare') }"> </mat-divider>
            }
            @if (shouldShowTool('compare')) {
              <button
                (click)="toggleLayerSwipe()"
                [disabled]="$is3dActive()"
                [ngClass]="{ 'hidden-mobile': !shouldShowToolMobile('compare') }"
                [title]="$is3dActive() ? 'Ikke tilgjengelig i 3D-modus' : 'Sammenlikn øverste kartlag med laget under'"
                mat-menu-item>
                <mat-icon class="black-icon">compare</mat-icon>
                Sammenligne kartlag
              </button>
            }

            <!-- Upload -->
            @if (shouldShowTool('addGPS')) {
              <mat-divider [ngClass]="{ 'hidden-mobile': !shouldShowToolMobile('addGPS') }"> </mat-divider>
            }
            @if (shouldShowTool('addGPS')) {
              <button
                (click)="openUploadDialog()"
                [ngClass]="{ 'hidden-mobile': !shouldShowToolMobile('addGPS') }"
                title="Last opp geometridata fra fil"
                mat-menu-item>
                <mat-icon class="black-icon">library_add</mat-icon>
                Last opp fil
              </button>
            }

            <!-- Report -->
            <ng-container>
              @if (shouldShowTool('arealrapport')) {
                <mat-divider
                  [ngClass]="{
                    'hidden-mobile': !shouldShowToolMobile('arealrapport'),
                  }">
                </mat-divider>
              }
              @if (shouldShowTool('arealrapport')) {
                <button
                  (click)="openAreaReportDialog()"
                  [disabled]="$is3dActive()"
                  [ngClass]="{
                    'hidden-mobile': !shouldShowToolMobile('arealrapport'),
                  }"
                  [title]="$is3dActive() ? 'Ikke tilgjengelig i 3D-modus' : 'Åpne rapportverktøy'"
                  mat-menu-item>
                  <mat-icon class="black-icon">description</mat-icon>
                  Arealrapport
                </button>
              }
              @if (shouldShowTool('soilreport')) {
                <mat-divider
                  [ngClass]="{
                    'hidden-mobile': !shouldShowToolMobile('soilreport'),
                  }">
                </mat-divider>
              }
              @if (shouldShowTool('soilreport')) {
                <button
                  (click)="openSoilReportDialog()"
                  [disabled]="$is3dActive()"
                  [ngClass]="{
                    'hidden-mobile': !shouldShowToolMobile('soilreport'),
                  }"
                  [title]="$is3dActive() ? 'Ikke tilgjengelig i 3D-modus' : 'Åpne rapportverktøy'"
                  mat-menu-item>
                  <mat-icon class="black-icon">description</mat-icon>
                  Arealrapport jordsmonn
                </button>
              }
              @if (shouldShowTool('reportForest')) {
                <mat-divider
                  [ngClass]="{
                    'hidden-mobile': !shouldShowToolMobile('reportForest'),
                  }">
                </mat-divider>
              }
              @if (shouldShowTool('reportForest')) {
                <button
                  (click)="openForestReportDialog()"
                  [disabled]="$is3dActive()"
                  [ngClass]="{
                    'hidden-mobile': !shouldShowToolMobile('reportForest'),
                  }"
                  [title]="$is3dActive() ? 'Ikke tilgjengelig i 3D-modus' : 'Åpne rapportverktøy'"
                  mat-menu-item>
                  <mat-icon class="black-icon">description</mat-icon>
                  Skograpport
                </button>
              }
            </ng-container>

            <!-- Kostra -->
            @if (shouldShowTool('kostra')) {
              <mat-divider [ngClass]="{ 'hidden-mobile': !shouldShowToolMobile('kostra') }"> </mat-divider>
            }
            <a class="black-icon" href="https://kart9.nibio.no/kostra/" target="_blank">
              @if (shouldShowTool('kostra')) {
                <button [ngClass]="{ 'hidden-mobile': !shouldShowToolMobile('kostra') }" mat-menu-item>
                  <mat-icon class="black-icon">assessment</mat-icon>
                  Arealberegning Kostra
                </button>
              }
            </a>

            <!-- Print -->
            @if (currentTopicId !== 'viltkart' && !$is3dActive()) {
              <mat-divider class="hidden-mobile"></mat-divider>
            }
            @if (currentTopicId !== 'viltkart' && !$is3dActive()) {
              <button (click)="openPrintDialog()" class="hidden-mobile" mat-menu-item>
                <mat-icon class="black-icon">print</mat-icon>
                Skriv ut/lagre
              </button>
            }

            <!-- 3D -->
            @if (shouldShowTool('3D')) {
              <mat-divider></mat-divider>
              <button (click)="toggle3d(!$is3dActive())" mat-menu-item>
                <mat-icon class="black-icon">3d_rotation</mat-icon>
                Slå {{ $is3dActive() ? 'av' : 'på' }} 3D-visning
              </button>
            }
          </mat-menu>

          <!--Link, Gårdskart og informasjon-->
          @if (name !== 'vega') {
            <nav class="toolbar-nav-right hidden-mobile">
              <ul>
                <li (keydown.enter)="$event.stopPropagation()" class="toolbar-nav-right-item">
                  <a tabindex="-1">
                    <button class="toolbar-nav-tools navigation-style tools-btn" (click)="getPermalink()">
                      <mat-icon>link</mat-icon>
                      <span>Link</span>
                    </button>
                  </a>
                </li>
                <li (keydown.enter)="$event.stopPropagation()" class="toolbar-nav-right-item">
                  <button (click)="triggerFarmsMap()" class="toolbar-nav-tools navigation-style tools-btn">
                    <mat-icon>agriculture</mat-icon>
                    <span>Gårdskart</span>
                  </button>
                </li>
                <li class="toolbar-nav-right-item">
                  <kilden3-infolinks></kilden3-infolinks>
                </li>
              </ul>
            </nav>
          }

          @if (name !== 'vega') {
            <div class="toolbar-nav-right show-mobile">
              <button
                (keydown.enter)="$event.stopPropagation()"
                [class.opened]="panelOpenState"
                aria-label="Verktøymeny"
                class="toolbar-nav-tools no-margin-right navigation-style"
                multi
                (click)="toggleHamburgerPanel()">
                <mat-icon class="mat-icon-big">menu</mat-icon>
              </button>
            </div>
          }
        </mat-panel-description>
      </mat-expansion-panel-header>

      <!--Hamburgermenu on mobil-->
      <span
        (click)="$event.stopPropagation()"
        (keydown.tab)="$event.stopPropagation()"
        (keydown.shift.tab)="$event.stopPropagation()"
        cdkTrapFocus
        class="mat-list-item-container">
        <button
          #matMenuTriggerMobile="matMenuTrigger"
          tabindex="0"
          class="mat-list-item-first"
          mat-menu-item
          [matMenuTriggerFor]="toolsmenu">
          <mat-icon class="black-icon">construction</mat-icon>
        </button>
        <div class="mat-list-item-right">
          <button mat-menu-item (click)="getPermalink()">
            <mat-icon class="black-icon">link</mat-icon>
          </button>
          <button mat-menu-item (click)="triggerFarmsMap()">
            <mat-icon class="black-icon">agriculture</mat-icon>
          </button>
          <!--button  mat-menu-item ><mat-icon class="black-icon" fontSet="material-icons-outlined">announcement</mat-icon></button-->
          <kilden3-infolinks></kilden3-infolinks>
        </div>
      </span>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<!-- prettier-ignore -->
<div id="farmMapPopover" class="farms-map-popover-content" [class.active]="isActive">
  Zoom inn til ønsket gård, trykk rød prikk for å vise info om driftssenteret
  og finne direktelenke til eiendommen i Gårdskart.
</div>
